<template>
    <section v-loading="loading" :class="isPc ? 'pc' : ''">
        <el-tabs :tab-position="tabsPosition" style="padding: 20px">
            <el-tab-pane :label="$t('pages.personInfo.tabsBase')" style="padding: 8px 30px">
                <div class="title">{{$t('pages.personInfo.baseTitle')}}</div>
                <el-form ref="editForm" :model="editForm" :rules="editFormRules" label-position="top" label-width="80px" @submit.native.prevent>
                    <el-row :gutter="50">
                        <el-col :sm="12" :xs="24">
                            <el-row>
                                <el-col :sm="24" :xs="24">
                                    <el-form-item :label="$t('pages.personInfo.loginId')" prop="loginId">
                                        <el-input v-model="editForm.loginId" disabled />
                                    </el-form-item>
                                    <el-form-item :label="$t('pages.personInfo.deptName')" prop="deptName">
                                        <el-input v-model="editForm.deptName" disabled />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :sm="24" :xs="24">
                                    <el-form-item :label="$t('pages.personInfo.realName')" prop="realName">
                                        <el-input v-model="editForm.realName" />
                                    </el-form-item>
                                    <el-form-item :label="$t('pages.personInfo.remark')">
                                        <el-input v-model="editForm.remark" type="textarea" rows="4" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-col>

                        <el-col :sm="12" :xs="24">
                            <el-form-item :label="$t('pages.personInfo.avatar')">
                                <el-image class="el-avatar el-avatar--square" style="height: 96px; width: 110px; line-height: 90px">
                                    <template #error>
                                        <img src="../../assets/img/logo.png" />
                                    </template>
                                </el-image>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :sm="12" :xs="24">
                            <el-form-item>
                                <el-button type="primary" @click="saveEdit()">{{$t('pages.personInfo.updateProfile')}}</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-tab-pane>
            <el-tab-pane :label="$t('pages.personInfo.tabsSecurity')" style="padding: 8px 30px">
                <div class="title">{{$t('pages.personInfo.securityTitle')}}</div>
                <el-form ref="editPwdForm" :model="editPwdForm" :rules="editPwdFormRules" label-position="top" label-width="80px" @submit.native.prevent>
                    <el-row>
                        <el-col :sm="12" :xs="24">
                            <el-form-item :label="$t('pages.personInfo.oldPassword')" prop="oldPassword">
                                <el-input v-model="editPwdForm.oldPassword" type="text" show-password auto-complete="off" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :sm="12" :xs="24">
                            <el-form-item :label="$t('pages.personInfo.newPassword')" prop="newPassword">
                                <el-input v-model="editPwdForm.newPassword" show-password auto-complete="off" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :sm="12" :xs="24">
                            <el-form-item :label="$t('pages.personInfo.confirmPassword')" prop="confirmPassword">
                                <el-input v-model="editPwdForm.confirmPassword" show-password auto-complete="off" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :sm="12" :xs="24">
                            <el-form-item>
                                <el-button type="primary" @click="savePwd()">{{$t('pages.personInfo.updatePwd')}}</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-tab-pane>
        </el-tabs>
    </section>
</template>

<script>
export default {
    name: 'personInfo',
    data: function () {
        const validateNewPassword = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('pages.personInfo.rules.newRequired')));
            } else {
                if (this.editPwdForm.confirmPassword !== '') {
                    this.$refs.editPwdForm.validateField('confirmPassword');
                }
                callback();
            }
        };

        const validateConfirmPassword = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('pages.personInfo.rules.confirmRequired')));
            } else if (value !== this.editPwdForm.newPassword) {
                callback(new Error(this.$t('pages.personInfo.rules.mismatch')));
            } else {
                callback();
            }
        };

        const validdataOldPwd = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('pages.personInfo.rules.oldRequired')));
            } else if (value !== this.userInfo.passWord) {
                callback(new Error(this.$t('pages.personInfo.rules.oldError')));
            } else {
                callback();
            }
        };
        return {
            isPc: true,
            tabsPosition: 'left',
            editFormRules: {
                realName: [{ required: true, message: this.$t('pages.personInfo.rules.nameRequired'), trigger: 'blur' }]
            },
            editForm: {
                id: 0,
                realName: '',
                remark: '',
                loginId: '',
                deptName: ''
            },
            editPwdFormRules: {
                oldPassword: [
                    { required: true, message: '请输入旧密码', trigger: 'blur' },
                    { required: true, trigger: 'blur', validator: validdataOldPwd }
                ],
                newPassword: [{ required: true, validator: validateNewPassword, trigger: 'blur' }],
                confirmPassword: [{ required: true, validator: validateConfirmPassword, trigger: 'blur' }]
            },
            editPwdForm: {
                id: 0,
                password: '',
                oldPassword: '',
                newPassword: '',
                confirmPassword: '',
                version: 0
            },
            loading: false,
            editLoading: false,
            editPwdLoading: false,
            avatarLoading: false,
            avatarDefault: '../../assets/img/logo.png',
            userInfo: {}
        };
    },
    created() {
        this.userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
    },
    mounted: function () {
        this.editForm.realName = this.userInfo.realName;
        this.editForm.remark = this.userInfo.remark;
        this.editForm.loginId = this.userInfo.loginId;
        this.editForm.deptName = this.userInfo.deptName;
    },
    methods: {
        saveEdit() {
            this.$confirm(this.$t('pages.personInfo.confirmUpdateProfile'), this.$t('pages.personInfo.confirmTitle'), {
                type: 'warning'
            })
                .then(() => {
                    this.$refs['editForm'].validate((valid) => {
                        if (valid) {
                            this.userInfo.realName = this.editForm.realName;
                            this.userInfo.remark = this.editForm.remark;
                            this.$zybhttp
                                .post('Account/UserUpdate', this.userInfo)
                                .then((res) => {
                                    if (res.data.status == 0) {
                                        this.$notify.success(res.data.msg);
                                    } else {
                                        this.$notify.error(res.data.msg);
                                    }
                                })
                                .catch((err) => this.$notify.error(this.$t('pages.personInfo.networkAddError')));
                        } else {
                            this.$notify.error(this.$t('pages.personInfo.addFail'));
                            return false;
                        }
                    });
                })
                .catch(() => {});
        },
        savePwd() {
            this.$confirm(this.$t('pages.personInfo.confirmUpdatePwd'), this.$t('pages.personInfo.confirmTitle'), {
                type: 'warning'
            })
                .then(() => {
                    this.$refs['editPwdForm'].validate((valid) => {
                        if (valid) {
                            this.userInfo.passWord = this.editPwdForm.newPassword;
                            this.$zybhttp
                                .post('Account/UserUpdate', this.userInfo)
                                .then((res) => {
                                    if (res.data.status == 0) {
                                        this.$notify.success(res.data.msg);
                                    } else {
                                        this.$notify.error(res.data.msg);
                                    }
                                })
                                .catch((err) => this.$notify.error(this.$t('pages.personInfo.networkAddError')));
                        } else {
                            this.$notify.error(this.$t('pages.personInfo.updateFail'));
                            return false;
                        }
                    });
                })
                .catch(() => {});
        }
    }
};
</script>

<style scoped>
.title {
    margin-bottom: 22px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
}
.pc ::v-deep .el-tabs--left .el-tabs__header.is-left {
    margin-right: -1px;
}
.pc ::v-deep .el-tabs__content::before {
    content: '';
    position: absolute;
    bottom: 0;
    width: 4px;
    height: 100%;
    background-color: #c5c8ce;
    z-index: 0;
    top: 0;
}
</style>

<style >
.el-tabs__content {
    overflow: auto;
    height: 550px;
}
</style>
